var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOpen = function SvgIconOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 .4C19.959.4 25.6 6.041 25.6 13S19.959 25.6 13 25.6.4 19.959.4 13 6.041.4 13 .4m.126 9.494c-.425 0-.77.33-.77.736v9.216c.012.396.352.714.77.714.425 0 .77-.33.77-.736v-9.216c-.012-.396-.352-.714-.77-.714m0-4.706c-.766 0-1.386.632-1.386 1.412s.62 1.411 1.386 1.411 1.386-.632 1.386-1.411c0-.78-.62-1.412-1.386-1.412"
  })));
};
export default SvgIconOpen;